import {
  Box,
  BoxProps,
  Icon,
  Text,
  ThemeTypings,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  RemixiconComponentType,
  RiEyeLine,
  RiPencilLine,
  RiShieldCheckLine,
  RiUploadCloudLine,
} from "@remixicon/react";

import { MemberRole } from "@reflag/shared/permissions";

type MemberRoleBadgeProps = BoxProps & {
  role: MemberRole;
};

export const MemberRoleDisplayOptions: Record<
  MemberRole,
  {
    icon: RemixiconComponentType;
    colorScheme: ThemeTypings["colorSchemes"];
    label: string;
    description: string;
  }
> = {
  admin: {
    icon: RiShieldCheckLine,
    colorScheme: "purple",
    label: "Admin",
    description: "Can manage all aspects of the organization.",
  },
  publisher: {
    icon: RiUploadCloudLine,
    colorScheme: "blue",
    label: "Writer",
    description: "Can create and update flags and environments.",
  },
  contributor: {
    icon: RiPencilLine,
    colorScheme: "blue",
    label: "Writer (except production)",
    description: "Can create and update flags except in production.",
  },
  viewer: {
    icon: RiEyeLine,
    colorScheme: "gray",
    label: "Viewer",
    description: "Read-only access to the organization.",
  },
} as const;

export function MemberRoleBadge({ role, ...props }: MemberRoleBadgeProps) {
  const config = MemberRoleDisplayOptions[role];

  const color = useColorModeValue(
    `${config.colorScheme}.500`,
    `${config.colorScheme}.400`,
  );

  if (!config) {
    return null;
  }

  return (
    <Box align="center" color={color} display={"inline"} {...props}>
      <Icon as={config.icon} boxSize={3} mb="-1px" mr={1} />
      <Text display="inline" fontWeight="medium">
        {config.label}
      </Text>
    </Box>
  );
}
